import React, { Component } from 'react';
import TodoItem from './TodoItem';

class TodoBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      todos: [],
      todo: '',
    }
  }

  onChangeInput = (event) => {
    this.setState({ todo: event.target.value});
    // console.log(this.state.todo);
  }

  onAddTodo = (event) => {
    const { todos, todo } = this.state;
    const valid = todo.trim();

    if(valid && event.key === 'Enter') {
      todos.push(todo);
      this.setState({ todo: '' })
      // console.log(todo);
    }
  }

  deleteTodo = (key) => {
    const { todos } = this.state;
    todos.splice(key, 1);
    this.setState({ todos: todos })
  }

  render() {
    const { todos } = this.state;

    return (
      <div className="todoBoard">

        <h2 className="boardTitle">{this.props.boardName}</h2>
        <button className="delBoardBtn" onClick={this.props.handleDeleteBoard}>&times;</button>
        <br />
        <div className="todoLength">There are {todos.length} todo</div>

        <div className="formTodo">
          <input className="todoInput" type="text" 
            onChange={this.onChangeInput} 
            value={this.state.todo} 
            placeholder="Enter your plan"
            onKeyDown={this.onAddTodo} />        
        </div>

        <div className="todoList">
          {todos.map((value, key) => {
            return(
              <TodoItem
                key={key}
                value={value}
                handleDeleteTodo={() => this.deleteTodo(key)} />
            );
          })}
        </div>

      </div>
    );
  }
}

export default TodoBoard; 





// WEBPACK FOOTER //
// ./src/components/TodoBoard.js